import * as React from 'react';

import { UitkNavigationType, UitkTab, UitkTabs, UitkTabsType } from 'uitk-react-tabs';

import { LodgingPwaPropertySearch } from '__generated__/api';

import NavigationTabs = LodgingPwaPropertySearch.NavigationTabs;

interface NavigationTabProps {
  navigationBarTabList: NavigationTabs;
}

export class SearchNavigationTab extends React.Component<NavigationTabProps> {
  public render() {
    const { navigationBarTabList } = this.props;

    return (
      <>
        {navigationBarTabList?.tabs?.length > 0 && (
          <div className={'search-nav-tab'}>
            <UitkTabs
              navigationType={UitkNavigationType.DEFAULT}
              tabsType={UitkTabsType.NATURAL}
              data-stid="search-nav-tabs"
              externalLinks={true}
              className={'main-region'}
            >
              {navigationBarTabList.tabs.map(
                tab =>
                  tab?.tabLink?.value && (
                    <UitkTab
                      id={tab.tabLink.value}
                      name={tab.tabLink.value}
                      className={`${tab.state?.toLowerCase()}`}
                      targetURI={tab.tabLink.link?.url}
                    />
                  )
              )}
            </UitkTabs>
          </div>
        )}
      </>
    );
  }
}
